export default __webpack_public_path__ + "media/images/steps/step-3-2210bbb84b2b38c3841ea9e7a148e901.svg";